var map = {
	"./Picture1.png": 8317,
	"./Picture10.png": 5161,
	"./Picture11.png": 7040,
	"./Picture12.png": 5371,
	"./Picture13.png": 546,
	"./Picture14.png": 5405,
	"./Picture15.png": 5156,
	"./Picture16.png": 8367,
	"./Picture17.png": 5078,
	"./Picture18.png": 2385,
	"./Picture19.png": 8520,
	"./Picture2.png": 7110,
	"./Picture20.png": 5700,
	"./Picture21.png": 6829,
	"./Picture3.png": 8655,
	"./Picture4.png": 3280,
	"./Picture5.png": 9529,
	"./Picture6.png": 6594,
	"./Picture7.png": 7099,
	"./Picture8.png": 5708,
	"./Picture9.png": 7973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7972;